import React, { forwardRef } from 'react';
interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  required?: boolean;
}
export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(({
  label,
  error,
  required,
  className = '',
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-173">
        {label && <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-174">
            {label}
            {required && <span className="text-[#FF3B30] ml-1" data-id="element-175">*</span>}
          </label>}
        <textarea ref={ref} className={`w-full px-4 py-2 border ${error ? 'border-[#FF3B30]' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF3B30] focus:border-[#FF3B30] transition-colors resize-vertical ${className}`} {...props} data-id="element-176" />
        {error && <p className="mt-1 text-sm text-[#FF3B30]" data-id="element-177">{error}</p>}
      </div>;
});
TextArea.displayName = 'TextArea';